import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Segment
} from 'semantic-ui-react'

const CardLeavePolicyUX = (props: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        id="CardLeavePolicyUX-div-0"
        style={{ width: "100%", height: "100%", padding: "10px" }}>
        <div
          id="CardLeavePolicyUX-div-7"
          style={{"width":"100%","height":"100%","display":"grid","position":"relative","gridTemplateRows":"repeat(1, 1fr)","gridTemplateColumns":"repeat(3, 1fr)"}}>
          <div
            id="CardLeavePolicyUX-div-8"
            style={{ gridRow: "1/2", gridColumn: "1/2", }}>
            <Segment
              id="CardLeavePolicyUX-Segment-10">
              <div
                id="CardLeavePolicyUX-div-12">
                {props.leaveTypeList}
              </div>
            </Segment>
          </div>
          <div
            id="CardLeavePolicyUX-div-9"
            style={{ gridRow: "1/2", gridColumn: "2/4", height: "100%", overflow: "auto" }}>
            <div
              id="CardLeavePolicyUX-div-13">
              {props.leaveSettingsPanel}
            </div>
          </div>
        </div>
      </div>
    )
}


export default CardLeavePolicyUX

export const screenPropsDefault = {}

/* Date Time : Thu May 29 2025 12:10:35 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardLeavePolicyUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", height: \"100%\", padding: \"10px\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 7,
      "label": "divgrid",
      "name": "div",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardLeavePolicyUX-div-7"
        },
        "style": {
          "type": "code",
          "value": "{\"width\":\"100%\",\"height\":\"100%\",\"display\":\"grid\",\"position\":\"relative\",\"gridTemplateRows\":\"repeat(1, 1fr)\",\"gridTemplateColumns\":\"repeat(3, 1fr)\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "div",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardLeavePolicyUX-div-8"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"1/2\", gridColumn: \"1/2\", }"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardLeavePolicyUX-div-9"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"1/2\", gridColumn: \"2/4\", height: \"100%\", overflow: \"auto\" }"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "Segment",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardLeavePolicyUX-Segment-10"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 10,
      "props": {
        "children": {
          "type": "code",
          "value": "props.leaveTypeList"
        },
        "id": {
          "type": "value",
          "value": "CardLeavePolicyUX-div-12"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "code",
          "value": "props.leaveSettingsPanel"
        },
        "id": {
          "type": "value",
          "value": "CardLeavePolicyUX-div-13"
        }
      },
      "seq": 13,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": true,
  "name": "CardLeavePolicyUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
